// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.vrmodel.RentalManagerUserPropertyVrModelWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyVrModelAssociateListingResponseWebDto,
  UserPropertyVrModelAssociateModelResponseWebDto,
  UserPropertyVrModelGetAllVrModelsResponseWebDto,
} from '../..';

interface AssociateListingParams {
  listingAlias: ListingAlias;
  shouldAssociate: boolean;
  vrModelId: number;
}
interface AssociateModelParams {
  encodedFloorplanKey: string;
  listingAlias: ListingAlias;
  shouldAssociate: boolean;
  vrModelId: number;
}
interface GetAllVrModelsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Path =
  '/api/web/v1/users/properties/vrModel/associateListing';

/**
 * Associate / Disassociate a vrModel to listing
 * @deprecated
 */
export const RentalManagerUserPropertyVrModelWebApiHandler_associateListing = (
  getParams: AssociateListingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AssociateListingParams, never, UserPropertyVrModelAssociateListingResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyVrModelWebApiHandler_associateListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Path =
  '/api/web/v1/users/properties/vrModel/associateModel';

/**
 * Associate / Disassociate a vrModel to a floor plan or unit
 * @deprecated
 */
export const RentalManagerUserPropertyVrModelWebApiHandler_associateModel = (
  getParams: AssociateModelParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AssociateModelParams, never, UserPropertyVrModelAssociateModelResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyVrModelWebApiHandler_associateModel_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path =
  '/api/web/v1/users/properties/vrModel/getAllVrModels';

/**
 * Retrieve all vr models
 */
export const RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels = (
  getParams: GetAllVrModelsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetAllVrModelsParams, never, UserPropertyVrModelGetAllVrModelsResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyVrModelWebApiHandler_getAllVrModels_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
